import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { IProblem } from "./IProblem";
import {IProblemSvc,problem_api} from "./IProblemSvc"


export class ProblemSvc implements IProblemSvc {
  

    public async get_problems_short(device_id:any, limit:number) : Promise<IProblem[]>  { 
        const problem_ret = await bus.api(problem_api.get_problems_short,  { device_id:device_id, limit:limit });
        return problem_ret;
    }

    public async get_machine_status() : Promise<IProblem[]>  { 
        const problem_ret = await bus.api(problem_api.get_machine_status,  {});
        return problem_ret;
    }

    public async create(device_id:any, user:string) : Promise<IProblem | undefined>  { 
        const problem_ret = await bus.api(problem_api.create, { device_id: device_id, zglosil:user });
        return problem_ret;
    }

    public async find_by_id(_id:any) : Promise<IProblem | undefined>  { 
        const problem_ret = await bus.api(problem_api.find_by_id, { _id: _id });
        return problem_ret;
    }
  
    public async update(problem:IProblem): Promise<IProblem | undefined>  {
        const problem_ret = await bus.api(problem_api.update, problem);
        return problem_ret;
    }

    public async delete(problem:IProblem): Promise<IProblem | undefined>  {
        const problem_ret = await bus.api(problem_api.delete, problem);
        return problem_ret;
    }
  
}